// #3357 -- split FVD's free-text person.email into its distinct, trimmed,
// lower-cased addresses. Same rule as report-api's lib/email-match.js
// (commas, semicolons and whitespace separate addresses; empties dropped;
// duplicates removed). Duplicated rather than shared: report-api is a Lambda
// bundle and this is a browser bundle, and the rule is four lines.
export function splitEmailAddresses(field) {
  const out = [];
  for (const part of String(field ?? "").split(/[\s,;]+/)) {
    const n = part.trim().toLowerCase();
    if (n && !out.includes(n)) out.push(n);
  }
  return out;
}
